// extracted by mini-css-extract-plugin
export default {"alertWrapper":"LicenseWarning_alertWrapper__m75Q4","ctaBtn":"LicenseWarning_ctaBtn__fYhAN"};